import { useCallback } from 'react';
import { useSweepApi } from '../sweep';
import {
  AiSupportInstructionProperties,
  AiSupportInstructionUpdateableProperties,
} from '@server/ai';
import { SfAppElement } from '../../components/pages/ai-assistant/apps/AppsConnectionDialog';
import { AiAssistantConversation } from '../../components/pages/ai-assistant/types';

export const useAiSupportApiFacade = () => {
  const sweepApi = useSweepApi();

  return {
    get_ai_sessions: useCallback(async () => {
      const response = await sweepApi.get(`/ai-session`);
      return response.data as AiAssistantConversation[];
    }, [sweepApi]),

    put_mark_as_resolved: useCallback(
      async (sessionId: string, status: string) => {
        return await sweepApi.put(`/ai-session/${sessionId}`, { status });
      },
      [sweepApi],
    ),

    get_supported_apps: useCallback(async () => {
      const response = await sweepApi.get(`/utility-bar/apps`);
      return response.data as SfAppElement[];
    }, [sweepApi]),

    get_instructions: useCallback(async () => {
      const response = await sweepApi.get(`/ai-session/instructions`);
      return response.data as AiSupportInstructionProperties[];
    }, [sweepApi]),

    post_instructions: useCallback(
      async (instruction: Omit<AiSupportInstructionUpdateableProperties, 'id'>) => {
        const response = await sweepApi.post(`/ai-session/instructions`, instruction);
        return response.data as AiSupportInstructionProperties;
      },
      [sweepApi],
    ),

    put_instructions: useCallback(
      async (instructionId: string, instruction: AiSupportInstructionUpdateableProperties) => {
        const response = await sweepApi.put(
          `/ai-session/instructions/${instructionId}`,
          instruction,
        );
        return response.data as AiSupportInstructionProperties;
      },
      [sweepApi],
    ),

    delete_instructions: useCallback(
      async (instructionId: string) => {
        const response = await sweepApi.delete(`/ai-session/instructions/${instructionId}`);
        return response.data as AiSupportInstructionProperties;
      },
      [sweepApi],
    ),
  };
};
